<template>
	<section class="header">
		<div class="row">
			<div class="columns small-12 large-10 large-offset-1">
				<div class="text-wrapper">
					<h1 v-text="data.title"></h1>
					<div v-html="data.intro_text"></div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	props: ['data']
}
</script>